const AppConfiguration = {
    WEB_SERVICE_HOST: process.env.NODE_ENV === 'production' ? window.location.hostname :  window.location.hostname,
    WEB_SERVICE_PORT: process.env.NODE_ENV === 'production' ? ":8091" : ":8081",
    WEB_SERVICE_PROTOCOL: process.env.NODE_ENV === 'production' ? "https://" : "http://",
    WEB_SERVICE_UNSECURE_PATH: process.env.NODE_ENV === 'production' ? '/risws/app/' : '/riswsdev/app/',
    WEB_SERVICE_SECURE_PATH: process.env.NODE_ENV === 'production' ? '/risws/app/sc/' : '/riswsdev/app/sc/',
    CONTEXT_BACKEND: process.env.NODE_ENV === 'production' ? '/risws/' : '/riswsdev/'
};


export const APP_CONFIGURATION = AppConfiguration;

export const PATH_BACKNED = "@/dcm/";

export const SECURE_ENDPOINT = AppConfiguration.WEB_SERVICE_PROTOCOL.concat(
    AppConfiguration.WEB_SERVICE_HOST,
    AppConfiguration.WEB_SERVICE_PORT,
    AppConfiguration.WEB_SERVICE_SECURE_PATH
);
export const UNSECURE_ENDPOINT = AppConfiguration.WEB_SERVICE_PROTOCOL.concat(
    AppConfiguration.WEB_SERVICE_HOST,
    AppConfiguration.WEB_SERVICE_PORT,
    AppConfiguration.WEB_SERVICE_UNSECURE_PATH
);
